// extracted by mini-css-extract-plugin
module.exports = {"WEIGHT":"300","PATH":"/app/themes/strazzanti/dist/font/f37ginger-light.2120f436ae629c596dc1.ttf","NAME":"F37 Ginger","STYLE":"normal"};